<template>
  <div>
    <div id="_div" class="w-100">
      <div id="Titulo_div">
        <h1>Mi Agenda</h1>
        <h3 v-show="!mostrarMensajeSinCitas">Consulte sus citas y cancele de ser necesario.</h3>
        <h3 v-show="mostrarMensajeSinCitas" class="text-danger">{{MENSAJE_SIN_CITAS}}</h3>
      </div>
      <div class="row">
        <!-- Filtro de búsqueda -->
        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-3 mb-3">
          <div class="area">
            <h4 v-show="mostrarCalendario">Filtros</h4>
            <h4 v-show="mostrarCita">Buscador</h4>
            <hr />
              <div v-show="mostrarCalendario">
                <div class="clearfix">
                    <div class="float-right ancho_botones">
                        <button type="button" class="btn btn-primary overwrapDeBotones" @click="limpiarFiltros()" style="height:auto"><i class="fas fa-eraser fa-lg"></i>&nbsp;&nbsp;Limpiar Filtros</button>
                    </div> 
                </div>
                <hr />
                <div id="areas">
                    <h6>Juzgado</h6>
                    <CAreas  
                      v-on:valorParaElPadre="cambioArea"
                      :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      :idDelInput="'catalogoAreas'" 
                      :parametros="parametros_Areas" 
                      :valorDefinido="verificarValorId(parametros_Areas.AreaSelecccionadaId)? parametros_Areas.AreaSelecccionadaId : parametros_Areas.ValorDefinido"
                      >
                    </CAreas> 
                </div>
                <div id="tipoEstatusDeCita">
                    <h6>Estatus de Cita</h6>
                    <CTiposEstatusDeCitas  
                      v-on:valorParaElPadre="cambioTipoEstatusDeCita"
                      :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      :idDelInput="'catalogoTipoEstatusDeCita'" 
                      :parametros="parametros_TiposEstatusDeCitas" 
                      :valorDefinido="verificarValorId(parametros_TiposEstatusDeCitas.TipoEstatusDeCitaSelecccionadoId)? parametros_TiposEstatusDeCitas.TipoEstatusDeCitaSelecccionadoId : parametros_Areas.ValorDefinido"
                      >
                    </CTiposEstatusDeCitas> 
                </div>
                <div class="form-group" id="fecha_div">
                  <h6>Fecha </h6>
                  <input 
                      v-model="filtrosDeBusqueda.fecha" 
                      type="date" 
                      id="fecha" 
                      :min="fechaMinima"
                      :max="fechaMaxima"
                      class="form-control espacio_base"
                      v-on:blur="cambiarDateFecha($event)"
                      />
                </div>
              </div>
            <div class="form-group" id="folio_div">
              <h6>Folio</h6>
              <input 
                  type="number" 
                  id="folioDeCita" 
                  v-model="filtrosDeBusqueda.folioDeCita" 
                  class="form-control espacio_base"
                  placeholder="Folio de cita"
                  v-on:keyup="filtrarListadoDeEventosCitas()"
              />
            </div>
            <hr />
            <div v-if="mostrarCita" class="clearfix">
                <div class="float-right ancho_botones">
                    <button type="button" class="btn btn-primary overwrapDeBotones" @click="buscarFolio()" style="height:auto"><i class="fas fa-search fa-lg"></i>&nbsp;&nbsp;Buscar</button>
                </div> 
            </div>
          </div>
        </div>
        <!-- Calendario -->
        <div v-show="mostrarCalendario" id="CalendarioAgendaDeCitas_div" class="col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-9">
          <div class="area">
              <h4>Calendario de citas a juzgado</h4>
              <hr />
              <div>
                <h6 class="mb-2">Estatus principales de citas y su definición de colores.</h6>
                <h6 style="background-color:rgba(192,192,192,0.5);" class="pl-3 pr-3 mb-2 descripcionColores">Citas Antiguas.</h6>
                <h6 style="background-color:rgb(46, 184, 46);" class="pl-3 pr-3 mb-2 descripcionColores">Citas Aceptadas.</h6>
                <h6 style="background-color:rgb(0,191,255);" class="pl-3 pr-3 mb-2 descripcionColores">Citas Creadas.</h6>
                <h6 style="background-color:rgba(200,0,0,0.5);" class="pl-3 pr-3 mb-2 descripcionColores">Citas Canceladas.</h6>
              </div>
              <br />
              <full-calendar id="calendario_miagenda_siccij" :events="eventosFullCalendar" :config="configuracionFullCalendar" ref="calendar" @event-selected="calendarioEventoClic" key="fullcalendarKey"></full-calendar>
              <hr />
          </div>
        </div>
        <!-- Información de Cita -->
        <div v-if="mostrarCita && Cita!=undefined && Cita!= null" id="Cita_div" class="col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-9">
          <div class="area">
            <h4>Información de Cita</h4>
            <hr />
            <div class="ml-3"><h6 style="display:inline-block" class="text-secondary">Folio de Cita:</h6><h6 class="pl-3" style="display:inline-block">{{Cita.CitaId}}</h6></div>
            <div class="ml-3"><h6 style="display:inline-block" class="text-secondary">Fecha y hora:</h6><h6 class="pl-3 text-wrap" style="display:inline-block">{{obtenerFechaYHora()}}</h6></div>
            <div class="ml-3"><h6 style="display:inline-block" class="text-secondary">Lugar:</h6><h6 class="pl-3 text-wrap" style="display:inline-block">{{Cita.Area.Area_PJ.Nombre}}</h6></div>
            <div class="ml-3"><h6 style="display:inline-block" class="text-secondary">Estatus de cita:</h6><h6 class="pl-3 text-wrap" style="display:inline-block">{{Cita.TipoEstatusDeCita.Nombre}}</h6></div>
            <div class="ml-3" v-if="Cita.TipoEstatusDeCita.TipoEstatusDeCitaId == 5"><h6 style="display:inline-block" class="text-warning">No olvide revisar su correo electrónico personal para más detalles.</h6></div>
            <div id="tablaDeTramites_div" class="table-responsive col-12">
                <div id="tablaDeTramites_texto_div">
                    <span></span>
                </div>
                <table class="table table-striped table-light table-hover table-bordered table-condensed" id="tablaDeTramites_table" 
                    data-search="false" 
                    data-toggle="tablaDeTramites_table" 
                    data-pagination="false" 
                    data-toolbar="#tablaDeTramites_texto_div"
                    data-page-size="5"
                    data-page-list="[2,5,10]"
                    data-undefined-text="Sin información"
                    data-minimum-count-columns="0">
                    <thead class="thead-dark">
                        <tr>
                          <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:16%" class="text-center align-middle">Folio de Trámite</th>
                          <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:28%" class="text-center align-middle">Trámite</th>
                          <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:28%" class="text-center align-middle">Expedientes</th>
                          <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:28%" class="text-center align-middle">Estatus de Expedientes</th>
                        </tr>
                    </thead>
                    <tbody class="text-dark">
                      <template  v-for="(Tramite) in Cita.TramitesCita">
                        <tr v-for="(Expediente, indexExp) in Tramite.Expedientes" :key="Expediente.ExpedienteId">
                            <td v-if="indexExp === 0" :rowspan="Tramite.Expedientes.length" class="text-center align-middle">{{ Tramite.TramiteCitaId }}</td>
                            <td v-if="indexExp === 0" :rowspan="Tramite.Expedientes.length" class="text-center align-middle">{{ Tramite.TipoTramite.Nombre }}</td>
                            <td class="text-center align-middle">{{ Expediente.TipoDocumento_DBPJ.Nombre }} : {{ Expediente.NumeroDeExpediente }} </td>
                            <td class="text-center align-middle">{{ Expediente.TipoEstatusDeExpediente.Nombre }} </td>
                        </tr>
                      </template>
                    </tbody>
                </table>
            </div>
            <hr />
            <div class="d-flex row">
                <div class="col-12 col-sm-12 col-md-4 col-lg-5 col-xlg-4 pb-2 text-left">
                    <button type="button" class="btn btn-primary overwrapDeBotones" @click="regresarACalendario()"><i class="fas fa-arrow-alt-circle-left fa-lg"></i>&nbsp;&nbsp;Regresar a calendario</button>
                </div>
                <div class="d-sm-none d-md-none d-xlg-block col-lg-1 col-xlg-1"></div>
                <div class="col-12 col-sm-12 col-md-8 col-lg-7 col-xlg-7 pb-1 text-right">
                    <button v-if="sePuedeGenerarComprobante()" type="button" class="btn btn-primary overwrapDeBotones mb-1" @click="generarPDF()"><i class="fas fa-file fa-lg"></i>&nbsp;&nbsp;Generar comprobante de cita</button>
                    <button v-if="sePuedeCancelar()" type="button" class="btn btn-primary overwrapDeBotones mb-1" @click="cancelarCita()"><i class="fas fa-times-circle fa-lg"></i>&nbsp;&nbsp;Cancelar Cita</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import FullCalendar from '@/../static/js/fullcalendar'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import moment from 'moment'
  import store from '@/store/index'
  import LogoPJE from '@/../src/assets/logo-pj-transparente-negro.png'
  
  export default {
    components: {
      CAreas: catalogos.SICCIJ.C001Areas,
      CTiposEstatusDeCitas: catalogos.SICCIJ.C012TiposEstatusDeCitas,
      FullCalendar
    },
    data() {
      return {
        enumeraciones,
        catalogos,
        Cita:null,
        fechaDiaHabilAnteriorALaCita: null,
        fullcalendarKey: 0,
        mostrarCita:false,
        mostrarCalendario:true,
        fechaMinima: moment().add(-30, 'days').format('YYYY-MM-DD'),
        fechaMaxima: moment().add(7, 'days').format('YYYY-MM-DD'),
        elementoSeleccionado:'',
        mostrarMensajeSinCitas:false,
        MENSAJE_SIN_CITAS:'',
        parametros_Areas: {
          ValorDefinido : -1,
          AreaSelecccionadaId: null,
          AreaId: null,
          AreaPJSeleccionadaId: null,
          ConInactivas: false,
          ConOrdenamiento: true,
          deshabilitarSelectAreas: false
        },
        parametros_TiposEstatusDeCitas: {
          ValorDefinido : -1,
          TipoEstatusDeCitaId: null,
          TipoEstatusDeCitaSeleccionadoId: null,
          CitaId: null            
        },
        filtrosDeBusqueda:{
          fecha: null,
          folioDeCita:null
        },
        funcionActivacion: "cargaCitasCalendario()",
        eventosCompletosFullCalendar: [],
        eventosFullCalendar: [],
        configuracionFullCalendar: 
        {
          slotLabelFormat: 'h:mma',
          header: 
          {
            left: 'prev,today,next',
            center: 'title',
            right: 'month,agendaWeek,agendaDay,list'
          },
          defaultView: 'list',
          editable: false,
          businessHours: 
          {
            daysOfWeek: [ 1, 2, 3, 4, 5], // Monday - Friday
            start: '08:30:00', // a start time (10am in this example)  parametros.horarioAtencionInicio
            end: '14:00:00', // an end time (6pm in this example) parametros.horarioAtencionFinal
          },
          defaultDate: moment().format('YYYY-MM-DD'),
          selectConstraint: "businessHours",
          weekends:false,
          minTime:'08:30',
          maxTime:'14:00',
          allDaySlot: false,
          defaultTimedEventDuration: '00:15:00',
          slotDuration: '00:15:00',
          slotLabelInterval: 15,
          selectable:false,
          contentHeight: 'auto',
          eventMouseover: function (data, event, view) 
          {                 
            var tooltip = '<div class="tooltiptopicevent" style="width:auto;height:auto;background:#212529;position:absolute;z-index:10001;padding:10px 10px 10px 10px ;  line-height: 200%;">' + data.description + '</div>';// + 'Audiencia: <br/>' + data.description + '</div>';
            $("body").append(tooltip);
            $(this).mouseover(function (e) 
            {
                $(this).css('z-index', 10000);
                $('.tooltiptopicevent').fadeIn('500');
                $('.tooltiptopicevent').fadeTo('10', 1.9);
            }).mousemove(function (e) 
            {
                $('.tooltiptopicevent').css('top', e.pageY + 10);
                $('.tooltiptopicevent').css('left', e.pageX + 20);
            });
          },
          eventMouseout: function (data, event, view) 
          {
            $(this).css('z-index', 8);
            $('.tooltiptopicevent').remove();
          }
        }
      }
    },
    props: {
    },
    mounted: function () {
    },
    methods: {
      /**
       * Función encargada de cambiar Area
       * @param {} datos [valor seleccionado del area]
       */
      cambioArea(datos) {
        var datosEvento = datos[0];
        var objetoArea = datos[1];
        
        this.parametros_Areas.AreaSelecccionadaId = parseInt(datosEvento.target.value);
        this.parametros_Areas.AreaPJSeleccionadaId = objetoArea!=undefined? objetoArea.AreaId_001DBPJ: null;
        this.filtrarListadoDeEventosCitas();
      },
      /**
       * Función encargada de cambiar tipo estatus de cita
       * @param {} datos [valor de seleccionado de tipo estatus de cita]
       */
      cambioTipoEstatusDeCita(datos) 
      {
        this.parametros_TiposEstatusDeCitas.TipoEstatusDeCitaSeleccionadoId = parseInt(datos.target.value);
        this.filtrarListadoDeEventosCitas();
      },
      /**
       * Función encargada de verificar el valor de un id dado
       * @param {} id [id a validar]
       */
      verificarValorId(id)
      {
          return (id != undefined && id != null && id > 0);
      },
      /**
       * Función encargada de filtrar los eventos del calendario en base a los parámetros proporcionados
       */
      filtrarListadoDeEventosCitas:function()
      {
        if(this.mostrarCalendario)
        {
          comun.SeEstaCargandoInformacion(true);
          this.eventosFullCalendar = [];
          this.eventosCompletosFullCalendar.forEach(eventoCita => {
            let agregar = true;
            if(this.verificarValorId(this.parametros_Areas.AreaSelecccionadaId) && eventoCita.Cita.AreaId != this.parametros_Areas.AreaSelecccionadaId)
              agregar = false;
            if(this.verificarValorId(this.parametros_TiposEstatusDeCitas.TipoEstatusDeCitaSeleccionadoId) && eventoCita.Cita.TipoEstatusDeCitaId != this.parametros_TiposEstatusDeCitas.TipoEstatusDeCitaSeleccionadoId)
              agregar = false;
            if(this.filtrosDeBusqueda.fecha != undefined && this.filtrosDeBusqueda.fecha != null && moment(eventoCita.Cita.AgendaBloque.FechaBloque).format('YYYY-MM-DD') != this.filtrosDeBusqueda.fecha)
              agregar = false;
            if(this.verificarValorId(this.filtrosDeBusqueda.folioDeCita))
            {
              if(!(eventoCita.Cita.CitaId.toString().includes(this.filtrosDeBusqueda.folioDeCita.toString()) || this.filtrosDeBusqueda.folioDeCita == eventoCita.Cita.CitaId))
                agregar = false;
            }
            if(agregar)
              this.eventosFullCalendar.push(eventoCita);
          });
          if(this.eventosFullCalendar != undefined && this.eventosFullCalendar != null && this.eventosFullCalendar > 1)
            this.mostrarDivCalendario();
          this.fullcalendarKey++;
          comun.SeEstaCargandoInformacion(false);
        }
        //this.fullcalendarKey++;
      },
      /**
       * Función encargada de buscar un folio en específico
       */
      buscarFolio:function()
      {
        if(this.verificarValorId(this.filtrosDeBusqueda.folioDeCita))
        {
          comun.SeEstaCargandoInformacion(true);
          const citaId = this.eventosCompletosFullCalendar.findIndex(cita => cita.id == this.filtrosDeBusqueda.folioDeCita); 
          if(citaId >= 0)
          {
            this.Cita = this.eventosCompletosFullCalendar[citaId].Cita;
            comun.SeEstaCargandoInformacion(false);
          }
          else
          {
            comun.SeEstaCargandoInformacion(false);
            comun.mensajeDeAlerta("No se encontró el folio " + this.filtrosDeBusqueda.folioDeCita + " dentro de sus citas agendadas de este mes, favor de verificarlo.", null, null);
          }
        }
        else
        {
          comun.mensajeDeAlerta("Ingrese un folio de cita para poder realizar la búsqueda.", null, null);
        }
        
      },
      /**
       * Función encargada de consultar en API las citas agendadas del usuario de la cuenta
       */
      cargaCitasCalendario: function () {
          comun.SeEstaCargandoInformacion(true);
          var peticion = { EsPrueba : this.enumeraciones.EsPrueba};
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false); 

          axios.post(
            api.conexion + api.SICCIJ.sistema.citas.MiAgenda.ObtenerEventosCita,
            peticion,
            headerPeticion
          ).then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              console.log(respuesta);
              if(respuesta.data.Error.Mensaje.includes('No tiene citas'))
              {
                this.MENSAJE_SIN_CITAS = respuesta.data.Error.Mensaje;
                this.mostrarMensajeSinCitas = true;
              }
              
            } else {
              this.mostrarMensajeSinCitas = false;
              this.eventosCompletosFullCalendar = respuesta.data.EventosCita;
              this.eventosFullCalendar = respuesta.data.EventosCita;
              this.fechaMaxima = moment(respuesta.data.FechaFinal).format('YYYY-MM-DD');
              this.mostrarDivCalendario();
            }
          comun.SeEstaCargandoInformacion(false);
          })
          .catch(e => {
              console.log("No Hay Respuesta del Servidor" + e);
          });
          
      },
      /**
       * Función encargada de cambiar la fecha del filtro
       * @param {} fechaElegidaEvent [evento de fecha elegida]
       */
      cambiarDateFecha(fechaElegidaEvent)
      {
        let fechaElegida = fechaElegidaEvent.target.value;
        if((fechaElegida > this.fechaMaxima))
        {
          comun.mensajeDeAlerta("La fecha no es válida, no hay citas para esa fecha.", null, null);
          this.filtrosDeBusqueda.fecha = null;
        }
        else if((fechaElegida < this.fechaMinima))
        {
          comun.mensajeDeAlerta("La fecha está fuera del rango. No se pueden consultar citas con más de un mes de antigüedad.", null, null);
          this.filtrosDeBusqueda.fecha = null;
        }
        else
        {
          this.filtrarListadoDeEventosCitas();
        } 
      },
      /**
       * Función desencadenada al dar clic a un evento del calendario.
       * @param {} event []
       */
      calendarioEventoClic: function(event, jsEvent, view)
      {
        this.Cita = event.Cita;
        this.fechaDiaHabilAnteriorALaCita = event.DiaHabilAnteriorALaCita? moment(event.DiaHabilAnteriorALaCita).format("DD/MM/YYYY"): null;
        this.mostrarDivCita();
      },
      /**
       * Función encargada de obtener la fecha y hora de cita 
       */
      obtenerFechaYHora:function()
      {
        moment.lang('es', {
          months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
          monthsShort: 'Ene._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.'.split('_'),
          weekdays: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sabado'.split('_'),
          weekdaysShort: 'Dom._Lun._Mar._Mier._Jue._Vier._Sab.'.split('_'),
          weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_')
        }
        );
        moment.locale('es');
        let fecha = moment(this.Cita.AgendaBloque.FechaHoraString, "DD/MM/YYYY HH:mm:ss").format("LLLL");
        return fecha + " hrs.";
      },
      /**
       * Función encargada de verificar que el campo de folio no tenga ningún valor y llamar a función mostrarDivCalendario
       */
      regresarACalendario:function()
      {
        if(this.verificarValorId(this.filtrosDeBusqueda.folioDeCita))
          this.filtrosDeBusqueda.folioDeCita = null;
        this.mostrarDivCalendario();        
      },
      /**
       * Función encargada mostrar el div de información de cita
       */
      mostrarDivCita:function()
      {
        this.mostrarCita = true;
        this.mostrarCalendario = false;
      },
      /**
       * Función encargada de mostrar el div de componente decalendario
       */
      mostrarDivCalendario:function()
      {
        this.mostrarCita = false;
        this.mostrarCalendario = true;
        this.Cita=null;
        this.fechaDiaHabilAnteriorALaCita = null;
      },
      /**
       * Función encargada de limpiar los filtros de búsqueda
       */
      limpiarFiltros:function()
      {
        $('#catalogoAreas').val(-1);
        $("#catalogoTipoEstatusDeCita").val(-1);
        this.parametros_Areas.AreaSelecccionadaId = null;
        this.parametros_Areas.AreaPJSeleccionadaId = null;
        this.parametros_TiposEstatusDeCitas.TipoEstatusDeCitaSeleccionadoId = null;
        this.filtrosDeBusqueda.folioDeCita = null;
        this.filtrosDeBusqueda.fecha = null;
        this.filtrarListadoDeEventosCitas();
      },
      /**
       * Función encargada de confirmar si se puede generar comprobante dependiendo el estatus de cita.
       */
      sePuedeGenerarComprobante:function()
      {
        let puedePuedeGenerarComprobante = true;
        let fecha = moment(this.Cita.AgendaBloque.FechaHoraString, "DD/MM/YYYY HH:mm:ss").fromNow(); 
        if(fecha.includes('hace') || 
           this.Cita.TipoEstatusDeCitaId == 3 || 
           this.Cita.TipoEstatusDeCitaId == 5)//moment(Cita.AgendaBloque.FechaBloque) >= moment() && Cita.TipoEstatusDeCitaId != 3 && Cita.TipoEstatusDeCitaId != 5
        {
          puedePuedeGenerarComprobante = false;
        }
        return puedePuedeGenerarComprobante;
      },
      /**
       * Función encargada de confirmar si se puede cancelar cita dependiendo del estatus de cita, hora del día y día habil anterior a la cita
       */
      sePuedeCancelar:function()
      {
        let puedeCancelarse = true;
        let hoyFecha = moment(new Date()).format("DD/MM/YYYY");
        let hoyHora = moment(new Date()).format("HH:mm:ss");
        let horaLimiteCancelar = "14:00";
        let fechaHoraDeCita = moment(this.Cita.AgendaBloque.FechaHoraString, "DD/MM/YYYY HH:mm:ss");
        let fecha = fechaHoraDeCita.fromNow(); 
        /*console.log("Fecha y hora de cita: ",fechaHoraDeCita);
        console.log("Cuanto falta desde hoy hasta la cita: ",fecha);
        console.log("Hora limite cancelar: ",horaLimiteCancelar);
        console.log("Hoy fecha: ", hoyFecha);
        console.log("Hoy hora: ", hoyHora);
        console.log("Fecha día hábil anterior a la cita: ",this.fechaDiaHabilAnteriorALaCita);
        console.log("Hay día hábil anterior a la cita: ",this.fechaDiaHabilAnteriorALaCita != undefined && this.fechaDiaHabilAnteriorALaCita != null);
        console.log("Día hábil anterior a la cita es null: ",!this.fechaDiaHabilAnteriorALaCita);
        console.log("fechaDiaHabilAnteriorALaCita == hoyFecha", this.fechaDiaHabilAnteriorALaCita == hoyFecha);
        console.log("hora hoy > hora limite", hoyHora >= horaLimiteCancelar);*/
        if(fecha.includes('hace') || 
           this.Cita.TipoEstatusDeCitaId == 3 || 
           this.Cita.TipoEstatusDeCitaId == 5 ||
           !this.fechaDiaHabilAnteriorALaCita ||
           (this.fechaDiaHabilAnteriorALaCita == hoyFecha && hoyHora > horaLimiteCancelar))
        {
          puedeCancelarse = false;
        }
        return puedeCancelarse;
      },
      /**
       * Función encargada de cancelar una cita.
       */
      cancelarCita:function()
      {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "Una vez cancelada la cita no podrá habilitarla de nuevo. ¿Desea continuar con la cancelación?",
          buttons: {
            cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
            },
            confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y cancelar'
            }
          },
          callback: (respuesta)=> {
            if (respuesta) 
            {
              comun.SeEstaCargandoInformacion(true);
              var peticion = { EsPrueba : this.enumeraciones.EsPrueba, CitaId : this.Cita.CitaId};
              const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false); 
              axios.post(
                api.conexion + api.SICCIJ.sistema.citas.MiAgenda.CancelarCita,
                peticion,
                headerPeticion
              ).then(respuesta => {
                if (respuesta.data.SiHayError) 
                {
                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                  console.log(respuesta);
                } 
                else 
                {
                  bootbox.dialog({
                    title: 'Mensaje del sistema',
                    message: respuesta.data.Satisfactorio,
                    size: 'medium',
                    buttons: {
                      aceptar: {
                        label: "Aceptar",
                        className: 'btn btn-primary',
                        callback: () => {
                          this.cargaCitasCalendario();
                        }
                      }
                    }
                  }); 
                }
                comun.SeEstaCargandoInformacion(false);
              })
              .catch(e => {
                console.log("No hay respuesta del Servidor" + e);
              });
            }
          }
        });
        
        
      },
      /**
       * Función encargada de generar el comprobante de cita
       */
      generarPDF: function () {
        var peticion = {
          "esPrueba": false,
          "CitaId": this.Cita.CitaId
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GetCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            console.log(response.data)
            var Cita = response.data.Cita
            var expedientes = "";
            /*expedientes += "<ul>";
            Cita.TramitesCita.forEach(function (Tramite) {
              expedientes += "<li>" + Tramite.TipoTramite.Nombre + "</li>"
              expedientes += "<ul>";
              Tramite.Expedientes.forEach(function (Expediente) {
                //console.log(Expediente.ExpedienteId);
                expedientes += "<li>"+Expediente.TipoDocumento_DBPJ.Nombre+" - " + Expediente.NumeroDeExpediente + "</li>";
              });
              expedientes += "</ul>";
            });
            expedientes += "</ul>";*/
            var contenidoPDF = "<table>" +
              "<tr><td><h4>Número de Folio: </h4></td><td style='padding-left:1em;'>" + this.Cita.CitaId + "</td><td rowspan='5'>" + expedientes + "</td></tr>" +
              "<tr><td><h4>Nombre del Solicitante: </h4></td><td style='text-transform: uppercase; padding-left:1em;'>" + Cita.InformacionDeSolicitante.Nombres + " " + (Cita.InformacionDeSolicitante.PrimerApellido != null? Cita.InformacionDeSolicitante.PrimerApellido + " " : "") + (Cita.InformacionDeSolicitante.SegundoApellido != null ? Cita.InformacionDeSolicitante.SegundoApellido : "") + "</td></tr>" +
              "<tr><td><h4>CURP: </h4></td><td style='text-transform: uppercase; padding-left:1em;'>" + Cita.InformacionDeSolicitante.CURP + "</td></tr>" +
              "<tr><td><h4>Fecha y hora de cita: </h4></td><td style='padding-left:1em;'> " + Cita.AgendaBloque.FechaHoraString + "</td></tr>" +
              "<tr><td><h4>Lugar: </h4></td><td style='padding-left:1em;'>" + Cita.Area.Area_PJ.Nombre + "</td></tr>" +
              "</table>"+
              "<div style='margin-top:1.5em;'><h2 style='display: inline;'>A T E N C I Ó N: </h2><span style='font-style: italic; font-size: 1.5em; display: inline;'>Por parte del Juzgado se le enviará a su <b>correo electrónico</b> la confirmación de su cita, para hacerle saber la disponibilidad de los expedientes o trámites solicitados; si no lo visualiza en la bandeja de entrada, revise su bandeja de 'spam' o 'correo no deseado' un día antes de su cita.</span></div>";
            
            var popupWin = window.open('', '_blank', 'location=no,left=100px');
            try {
              comun.SeEstaCargandoInformacion(false);
              popupWin.document.open(); 
              popupWin.document.write('<html><head><title>Comprobante de Cita</title>');
              popupWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
              popupWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
              popupWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
              popupWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
              popupWin.document.write('</head><body >')
              popupWin.document.write('<img src="' + LogoPJE +'" style="object-fit: cover; width: 10vw; height: 10vw;" alt="Logo de Poder Judicial del Estado de Aguascalientes"/>');
              popupWin.document.write('<h2>Comprobante de Cita </h2>')

              popupWin.document.write(contenidoPDF);
              popupWin.document.write('<hr></body></html>');

              setTimeout(
                function () { 
                  popupWin.print(); 
                }, 1000
              );

              popupWin.document.close();
              popupWin.focus(); 

            } catch (e) {
              console.log(e);
              comun.mensajeDeAlerta("Sucedió un error al generar su comprobante, asegúrese de tener habilitadas las <b style='color:yellow;'>ventanas emergentes</b>.", null, null);
            }
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      }
    },
    created() {
      this.cargaCitasCalendario();
    },
    computed:{
    }
  }
</script>

<style scoped>
    .padding-div-low {
        padding-top: 40px;
    }
    .alinear_izq { float: left; }
    .alinear_der { float: right; }
    .contenedor-puntero {
        background: #212529;
        border-radius:2px;
        padding: 10px;
        border:1px solid white;
        margin-bottom: 1.5em;
    }
    .fc-today {
        background: rgba(255,255,255,0.8) !important;
        border: none !important;
        /*border-top: 1px solid #ddd !important;
        font-weight: bold;*/
    } 
    .fc-time-grid .fc-slats td {
        height: 2em !important;
    }
    .fc-content, .fc-time, .fc-title {
        font-size: 1em;
        border-radius: 3px;
        border: 1px solid #ddd;
    }
</style>

<style>
    .padding-div-low {
        padding-top: 40px;
    }

    #calendario_miagenda_siccij .fc-view-container {
      background-color: transparent !important;
        color: #343a40 !important;
        border-color: #212529 !important;
        height: auto !important;
    }

    #calendario_miagenda_siccij .fc-view table {
        border-color: #212529 !important;
    }

    #calendario_miagenda_siccij .fc-axis {
        background-color: #504f54 !important;
        color: white !important;
        font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
    }

    #calendario_miagenda_siccij .fc-day-header {
        background-color: #212529 !important;
        color: white !important;
        font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
        padding: .75rem !important;
    }

    #calendario_miagenda_siccij .fc-button {
        background-color: whitesmoke !important;
        border: none !important;
        padding: .375rem 1.35rem !important;
        color: #212529 !important;
        text-shadow: none !important;
        display: inline-block !important;
        font-weight: 400 !important;
        text-align: center !important;
        white-space: nowrap !important;
        vertical-align: middle !important;
        font-size: 1rem !important;
        border-radius: .25rem !important;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
    }

    #calendario_miagenda_siccij .fc-state-active
    {
        background-color:  rgb(174, 174, 174) !important;
    }

    #calendario_miagenda_siccij .fc-button:focus {
        outline: none !important;
    }

    #calendario_miagenda_siccij .fc-today {
        background-color: rgba(242,242,242,0.5) !important;
        color: white !important;
    }

    #calendario_miagenda_siccij .fc-day-number{
        color: white !important;
    }

    #calendario_miagenda_siccij .fc-event {
        border-color: #32383e !important;
        color: white !important;
        padding: 0 .375rem !important;
        font-size: 1rem !important;
        border-radius: .25rem !important;
        width: 80% !important;
        /*height: 2rem;*/
        overflow-wrap: normal !important;
        text-align: center !important;
        margin: auto !important;
    }

    #calendario_miagenda_siccij .fc-list-item{
        color:white !important;
    }

    #calendario_miagenda_siccij .fc-list-item:hover{
        color:black !important;
    }
    .descripcionColores{
      display: inline-block;
      width: auto;
      text-align: center;
      border-radius: 0.25em;
    }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Citas/MiAgenda/MiAgenda.vue